module.exports = __webpack_public_path__ + "static/media/clamps.8273c5ca.JPG";